import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { chooseOptionsConstant, strengthAndUnitsOtherOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { DatePipe } from '@angular/common';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../message-box/message-box.component';
import { Document_Upload_File } from '../../../../models/common';
import { CommonService } from '../../../../services/common.service';
import { FilePreviewComponent } from 'src/app/common/document-summary/file-preview/file-preview.component';

import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'configure-template-view',
  templateUrl: './configure-template-view.component.html',
  styleUrls: ['./configure-template-view.component.scss']
})
export class ConfigureTemplateViewComponent implements OnInit {
  formFields;
  @Input() public Content:any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  labDetailsForm: UntypedFormGroup;
  strengthAndUnitsOptions = strengthAndUnitsOtherOptionsConstant;
  ApplicationID: any;
  PatientID: any;
  document_attach_list: Document_Upload_File[] = [];
  ScreensList: any = [];
  FileName: any;
  FileID: any;
  StatesList = [
    { "value": "0", "label": "InActive" },
    { "value": "1", "label": "Active" },
  ];
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    public commonService: CommonService,
    public datepipe: DatePipe    
  ) {
  }

  ngOnInit() {
    this.labDetailsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      SCREEN_ID: new UntypedFormControl(""),
      TEMPLATE_NAME: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      IS_ACTIVE: new UntypedFormControl(true),
    });

    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.summaryService.getScreenDataForEdit("api/ISTFileAttachments/EditTemplateDetails?TemplateID=" + this.Content.content.id).subscribe(criteria => {
        this.labDetailsForm.patchValue({
          ID: criteria["ID"],
          //SCREEN_ID: criteria["SCREEN_ID"],
          TEMPLATE_NAME: criteria["TEMPLATE_NAME"],
          State: criteria["State"],
          IS_ACTIVE: criteria["RECORD_STATE"],
        });
        let abc=criteria["SCREEN_ID"].split(",");
        this.labDetailsForm.controls["SCREEN_ID"].setValue(abc);
        this.FileName = criteria["FileName"];
        this.FileID = criteria["FileID"];
        if (this.Content.heading == "View") {
          this.labDetailsForm.disable();
        }
      });

    }

    this.getMasterData();
  }
  getMasterData() {
    this.summaryService.masterData("api/ISTFileAttachments/GetScreenNames?MODULE_ID=" + this.Content.content.MODULE_ID +"&TemplateID=" + this.Content.content.id+"&TemplateName="+this.Content.content.SUB_MODULE).subscribe(result => {
    this.ScreensList = result;
    this.ScreensList.forEach((item:any)=>
    {
      if(item.IsActive == false)
       item["icon"]="ieg_inactive_record";
    })
    });
  }
  DeleteUpload(file): void {
    if (file.Status == "Add") {
      let code = file.ID;
      this.document_attach_list = this.document_attach_list.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  DeleteSavedUpload(): void {
   var fileID = this.FileID;
   this.FileName= "";
   this.FileID= "";
   /*  this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + fileID).subscribe(result => {
      this.FileName= "";
      this.FileID= ""; */
    /* }); */
  }
  DownloadFile(fileID) {
    var fileID = this.FileID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID,fileName)
  {
    this.commonService.previewFile(fileID,fileName,"med");
    }
    
  uploadchange(event): void {
    if (this.document_attach_list == undefined || this.document_attach_list == null) {
      this.document_attach_list = [];
    }
    this.DeleteSavedUpload();
    //this.document_attach_list = [];
    var file = event.target.files[0].name;    
    var ext = file.match(/\.([^\.]+)$/)[1];
    var filesize = event.target.files[0].size;
    if (file != null && ((filesize > (1024 * 1024 * 10)) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
      this.commonService.ValidationBanner("Accepts only Word, PPT, Excel, pdf, Text file types with maximum 10mb size");
      //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: "Accepts only Word, PPT, Excel, Text file types with maximum 10mb size"} } });
    }
    else{
    for (let i = 0; i < event.target.files.length; i++) {
      this.document_attach_list = [];
      let uploadFile = new Document_Upload_File();
      uploadFile.ID = ("" + (i + 1));
      uploadFile.DOCUMENT_NAME = event.target.files[i].name;
      uploadFile.File = event.target.files[i];
      uploadFile.Status = "Add";
      this.document_attach_list.push(uploadFile);
    }
  }
  }
  SaveLabReports() {
    if (this.Validations()) { 
      var formData = this.labDetailsForm.value;

      var scrobj = this.ScreensList.filter(function (element) 
      {
        return formData.SCREEN_ID.indexOf(element.value)>-1;
      });
      let names=scrobj.map(x=>x.label).join(", ");      
      let ids= formData.SCREEN_ID.join(",");
      formData["SCREEN_ID"]=ids;
      formData["SCREEN_NAMES"] = names;
      formData["MODULEID"]=this.Content.content.MODULE_ID;
      formData["SUB_MODULE"] = this.Content.content.SUB_MODULE;

      formData.RECORD_STATE = formData.IS_ACTIVE == true ? 1 : 0;

      let formData1 = new FormData();
      if (this.document_attach_list != null && this.document_attach_list.length > 0) {
        for (let i = 0; i < this.document_attach_list.length; i++) {
          this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
          formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
        }
      }
      
      formData1.append("ScreenData", JSON.stringify(formData));

      if (this.Content.heading == "Edit") {
        this.summaryService.FilesInsert("api/ISTFileAttachments/Update", formData1).subscribe(result => {
          if (result.Status==0){
            this.commonService.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: result.Message } } });
          }
        });
      }
      else
      {
        this.summaryService.FilesInsert("api/ISTFileAttachments/Insert", formData1).subscribe(result => {
        if (result.Status==0){
          this.commonService.SuccessBanner(result.Message);
          
          this.modalRef.close();
        }
        else
        {
          if(formData["SCREEN_ID"]!=null && formData["SCREEN_ID"]!=undefined)
          {
             let list=formData["SCREEN_ID"];
             if(list!=null && list!=undefined)
             {
              let abc=formData["SCREEN_ID"].split(",");
              this.labDetailsForm.controls["SCREEN_ID"].setValue(abc);
             }
           
          }
          
          this.commonService.ValidationBanner(result.Message);
          //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: result.Message } } });
        }
        });  

      }
     
    }
  }

  Validations(): boolean {
    var message = "";
    var isValid = true;
    var formData = this.labDetailsForm.value;


    if (formData.TEMPLATE_NAME === null || formData.TEMPLATE_NAME === "" || formData.TEMPLATE_NAME === undefined) {
      $("#TEMPLATE_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#TEMPLATE_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Document Template Name<br/>";
      isValid = false;
    } else {
      $("#TEMPLATE_NAME").addClass("ng-untouched ng-valid");
      $("#TEMPLATE_NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    
    if (formData.SCREEN_ID == null || formData.SCREEN_ID == "" || formData.SCREEN_ID == undefined) {
      $("#SCREEN_ID").addClass("ng-touched ng-invalid validate-error");
      $("#SCREEN_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Applicable Screens<br/>";
      isValid = false;
    } else {
      $("#SCREEN_ID").addClass("ng-untouched ng-valid");
      $("#SCREEN_ID").removeClass("ng-touched ng-invalid validate-error");
    }
    
    if ((this.document_attach_list != null && this.document_attach_list.length > 0) || (this.FileName != "" && this.FileName!=undefined)) {
    }
    else {
      message += "Please Upload Document<br/>";
      isValid = false;
    }
    if (!isValid)
    this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  

}
